import React from 'react';
import { InventoryTransferDetailDTO } from '../../../../../../types/inventory/transfer/InventoryTransferDetailTypes';
import ModalInfoCard from '../../../../../../components/Cards/ModalInfoCard';
import SectionDivider from '../../../../../Dividers/SectionDivider';
import InfoRow from '../../../../../Rows/InfoRow';


interface Props {
  detail: InventoryTransferDetailDTO;
}

const TransferFlowSection: React.FC<Props> = ({ detail }) => {
  return (
    <>
      {/* ✅ Título + divisor */}
      <SectionDivider title="Flujo del Traslado" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">

        {/* ✅ Solicitud (siempre visible) */}
        <ModalInfoCard title="Solicitud">
          <InfoRow label="Solicitado por" value={detail.requestedByName} />
          <InfoRow label="Fecha solicitud" value={detail.requestedDate} />
          <InfoRow label="Hora solicitud" value={detail.requestedTime} />
        </ModalInfoCard>

        {/* ✅ Aprobación */}
        {detail.approvedById != null && (
          <ModalInfoCard title="Aprobación">
            <InfoRow label="Aprobado por" value={detail.approvedByName} />
            <InfoRow label="Fecha aprobación" value={detail.approvedDate} />
            <InfoRow label="Hora aprobación" value={detail.approvedTime} />
          </ModalInfoCard>
        )}

        {/* ✅ Confirmación */}
        {detail.confirmedById != null && (
          <ModalInfoCard title="Confirmación">
            <InfoRow label="Confirmado por" value={detail.confirmedByName} />
            <InfoRow label="Fecha confirmación" value={detail.confirmedDate} />
            <InfoRow label="Hora confirmación" value={detail.confirmedTime} />
          </ModalInfoCard>
        )}

        {/* ✅ Rechazo */}
        {detail.rejectedById != null && (
          <ModalInfoCard title="Rechazo">
            <InfoRow label="Rechazado por" value={detail.rejectedByName} />
            <InfoRow label="Fecha rechazo" value={detail.rejectedDate} />
            <InfoRow label="Hora rechazo" value={detail.rejectedTime} />
          </ModalInfoCard>
        )}

        {/* ✅ Cancelación */}
        {detail.cancelledById != null && (
          <ModalInfoCard title="Cancelación">
            <InfoRow label="Cancelado por" value={detail.cancelledByName} />
            <InfoRow label="Fecha cancelación" value={detail.cancelledDate} />
            <InfoRow label="Hora cancelación" value={detail.cancelledTime} />
          </ModalInfoCard>
        )}

      </div>
    </>
  );
};

export default TransferFlowSection;
